import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import AutoQuery from 'servicestack/auto-query/auto-query'
import $session from 'servicestack/session'

class AddressValidatorPromptController {
    constructor($rootScope, $uibModalInstance, $geo, options) {
        var $ctrl = this;
        basicController($ctrl);
		var model = $ctrl.model = options.model;
		var key = $ctrl.key = options.key;
		var bus = $ctrl.bus = new ServiceBus($rootScope);
		$ctrl.$uibModalInstance = $uibModalInstance;
		$ctrl.candidates = [];
		$geo.validateAddress(model, key).then(function (response) {
			$ctrl.ready = true;
			$ctrl.validAddress = response.isValid;
			$ctrl.candidates = response.candidates;
			if (response.candidates.length > 0) {
				$ctrl.dpv_match_code = response.candidates[0].analysis.dpv_match_code;
				$ctrl.model.latitude = response.candidates[0].metadata.latitude;
				$ctrl.model.longitude = response.candidates[0].metadata.longitude;
				$ctrl.selected = $ctrl.model;
			} else if (response.match) {
				$ctrl.selected = response.match;
			}
		});
		$ctrl.save = $ctrl.submit = function () {
			$ctrl.$uibModalInstance.close({ valid: true, selected: $ctrl.selected });
		};
    }
	dismiss(reason) {
		let $ctrl = this;
		$ctrl.$uibModalInstance.dismiss(reason);
	}
}

export default AddressValidatorPromptController;